
import api from '../services/api';
import {toastr} from 'react-redux-toastr'
import _ from 'lodash';

import { 

    EXTENSION_AVAILABLE, 
    LOADING,
    LOGOUT, 
} from './types';

export const onSubmitLogin = dados => {
    return async dispatch => {
        try {
            dispatch({ type: LOADING, payload: true });
            await api.post(`/api/agent` , dados);
            dispatch({ type: LOADING, payload: false });

        } catch (error) {
            dispatch({ type: LOADING, payload: false });


            if (error.response) {
                if(error.response.status==401) {
                    toastr.error('Error: '+error.response.status, error.response.data.message);

                    await localStorage.removeItem('token');
                    dispatch({ type: LOGOUT });
                }else{
                    toastr.error('Error: '+error.response.status, error.response.data.message +"\n"+error.response.data.datails);
                }
            }
        }

              
    }
}

export const onSubmitStatus = state => {
    return async dispatch => {
        dispatch({ type: LOADING, payload: true });  
        return await api.put(`/api/agent/state` , { state })
            .then( response => {
                dispatch({ type: LOADING, payload: false });
                toastr.success('Sucesso', 'Status alterado com sucesso')
                return true;
            } )
            .catch( async error => {
                dispatch({ type: LOADING, payload: false });
                if (error.response) {
                    if(error.response.status==401) {
                        toastr.error('Error: '+error.response.status, 'Seu acesso ao sistema se expirou !');

                        await localStorage.removeItem('token');
                        dispatch({ type: LOGOUT });
                    }else{
                        toastr.error('Error: '+error.response.status, error.response.data.message);
                    }
                }
                return false;
            })   
    }
}


export const listenerExtensionAvailable = extensionsAvailable => {
    return async dispatch => {
        const listenerExtensionAvailable = _.keyBy(extensionsAvailable, 'extension');
        dispatch({ type: EXTENSION_AVAILABLE, payload: listenerExtensionAvailable });
    }
}
export const verificaAgenteConectado = auth => {
    return async dispatch => {
  
    }
}

